import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyAA3aEXnWoNYb21AEziQgYLkplh--ztaIQ",
  authDomain: "projeto-fidelizapp.firebaseapp.com",
  projectId: "projeto-fidelizapp",
  storageBucket: "projeto-fidelizapp.firebasestorage.app",
  messagingSenderId: "743898277721",
  appId: "1:743898277721:web:90c4725979d56aa370ce48",
  measurementId: "G-17RVJ34W2T"
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);